import { ErrorBoundary } from "react-error-boundary";
import { NODE_ENV } from "../../../constants/env";
import { EmptyComponent } from "../../../legacy/components/common/EmptyComponent";
import { attemptChunkLoadRecovery } from "../../../lib/chunk-load-recovery/attempt-chunk-load-recovery";

function handleRouteError(error: Error): void {
  if (NODE_ENV === "development") {
    console.error(error);
    return;
  }

  if (attemptChunkLoadRecovery(error)) {
    return;
  }

  window.location.href = "/unexpected-error.html";
}

export function withRouteErrorBoundary(element: JSX.Element): JSX.Element {
  return (
    <ErrorBoundary FallbackComponent={EmptyComponent} onError={handleRouteError}>
      {element}
    </ErrorBoundary>
  );
}
